angular.module 'app'
.config (growlProvider) ->

  growlProvider.globalTimeToLive 3000
  growlProvider.globalPosition 'top-right'
